import { Navigate, Outlet } from 'react-router-dom';
import { useIsAdmin } from '@/hooks';
import Spinner from '@/components/Spinner';

const RequireAdmin = () => {
    const { isAdmin, isLoadingAdmin } = useIsAdmin();

    if (isLoadingAdmin) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="flex flex-col items-center gap-4">
                    <Spinner size={32} />
                    <p className="text-sm text-gray-500">Checking admin access...</p>
                </div>
            </div>
        );
    }

    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default RequireAdmin;
